import { createRouter } from "@tanstack/react-router"

import type { AuthContextType } from "./contexts/auth-context"
import { routeTree } from "./routeTree.gen"

export interface RouterContext {
  auth: AuthContextType
}

export const router = createRouter({
  routeTree,
  context: {
    auth: undefined!,
  } as RouterContext,
  defaultPreload: "intent",
  // Subtle native crossfade between routes (View Transitions API). Return [] to
  // run the default transition, false to skip. Skip when:
  //  - only search params change (e.g. ?tab=) so tab switches don't flash
  //  - the tab isn't visible — startViewTransition() rejects with
  //    InvalidStateError ("Transition was aborted…") on a hidden/inactive tab
  //    (React #34098), which surfaces as unhandled-rejection noise.
  defaultViewTransition: {
    types: ({ pathChanged }) =>
      pathChanged && (typeof document === "undefined" || document.visibilityState === "visible") ? [] : false,
  },
})

declare module "@tanstack/react-router" {
  interface Register {
    router: typeof router
  }
}
